module.exports = __webpack_public_path__ + "Bliss2-Medium.f69618d772c7da13d85d.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Medium.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Medium.woff2
// module chunks = styles